<div class="inline-container">
    <div class="inline-options">
        <mat-form-field class="inline-dropdown">
            <mat-label>Refresh every</mat-label>
            <mat-select [(value)]="autoRefreshInterval" (selectionChange)="autoRefreshIntervalChanged($event);">
                <mat-option [value]="120">2 Minutes</mat-option>
                <mat-option [value]="300">5 Minutes</mat-option>
                <mat-option [value]="600">10 Minutes</mat-option>
                <mat-option [value]="1200">20 Minutes</mat-option>
                <mat-option [value]="6000">1 Hour</mat-option>
            </mat-select>
        </mat-form-field>
        <button class="auto-refresh-btn" mat-raised-button
            matTooltip="Auto Refresh Results: Currently {{ autoRefresh === true ? 'Enabled' : 'Disabled' }}"
            (click)="toggleAutoRefresh();"><i class="material-icons">update</i> Auto Refresh: {{ autoRefresh === true ?
            'On' : 'Off' }}</button>
    </div>
</div>